/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';
import PrintTemplate from './PrintTemplate';
import { useReactToPrint } from 'react-to-print';

const ParticipentFeedback = () => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        reg_form: "Fresh",
        candidate_type: "",
        training_atten_date: "",
        training_date: new Date(),
        batch_no: "",
        training_title: "",
        sr_no: "",
        organization: "",
        work_location: "",
        incharge: "",
        sub_contractor: "",
        evaluation_option: "",
        payment_made_by: "",
        contract_number: "",
        passport_size: "",
        stamp_size: "",
        Name: "",
        designation: "",
        contact_no: "",
        qualification: "",
        date_of_birth: "",
        languages_known: "",
        total_year_exp: "",
        current_employer: "",
        LMV_HMV_license_no: "",
        types_of_cranes_handled: "",
        marital_status: "",
        fees_amount: "",
        present_address: "",
        permanent_address: "",
        pre_evaluation_test: "",
        service_tax: "",
        license_valid_from: "",
        license_valid_to: "",
        amount_status: "",
        checked_by: "",
        verify_by: "",
        trainers_name: "",
        training_module: "",
        trainers: "",
        training_facility: "",
        learn_something: "",
        learn_something_remark: "",
        about_food: "",
        recommend_colleague: "",
        recommend_colleague_remark: "",
        your_valuable_suggestions: "",
        feedback_status: "",
        feedback_date: ""
    });
    const [searchText, setSearchText] = useState('');
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');

    const [errors, setErrors] = useState({
        feedback_date: "",
        feedback_status: "",
    });

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);

    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers for the dropdown
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);

    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid
        return date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };

    const formatToDDMMYYYY = (dateStr) => {
        if (!dateStr) return "";
        const isoMatch = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const [, year, month, day] = isoMatch;
            return `${day}-${month}-${year}`;
        }
        const date = new Date(dateStr);
        if (isNaN(date)) return dateStr;
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no,
                training_title: row.training_title,
                sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location,
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option,
                payment_made_by: row.payment_made_by,
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled,
                marital_status: row.marital_status,
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: isValidDate(new Date(row.license_valid_from)) ? convertToYYYYMMDD(row.license_valid_from) : "",
                license_valid_to: isValidDate(new Date(row.license_valid_to)) ? convertToYYYYMMDD(row.license_valid_to) : "",
                amount_status: row.amount_status,
                checked_by: row.checked_by,
                verify_by: row.verify_by,
                trainers_name: row.trainers_name,
                training_module: row.training_module,
                trainers: row.trainers,
                training_facility: row.training_facility,
                learn_something: row.learn_something,
                learn_something_remark: row.learn_something_remark,
                about_food: row.about_food,
                recommend_colleague: row.recommend_colleague,
                recommend_colleague_remark: row.recommend_colleague_remark,
                your_valuable_suggestions: row.your_valuable_suggestions,
                feedback_status: row.feedback_status,
                feedback_date: row.feedback_date
            });
            $('#editRowModal').modal('show');
        }
    };

    const printRef = useRef();
    const [printData, setPrintData] = useState(null);

    const doPrint = useReactToPrint({
        contentRef: printRef,
    });
    useEffect(() => {
        if (printData) doPrint();
    }, [printData]);


    const handlePrint = async (row) => {
        try {
            const res = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/print/${row.mas_id}`);
            const r = res.data;
            setPrintData({
                name: r.Name,
                designation: r.designation,
                organization: r.organization,
                topic: r.training_title,
                faculty: r.trainers_name,
                date: `${String(new Date().getDate()).padStart(2, '0')}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${new Date().getFullYear()}`, training_module: r.training_module,
                trainers: r.trainers,
                training_facility: r.training_facility,
                about_food: r.about_food,
                learn_something: r.learn_something,
                recommend_colleague: r.recommend_colleague,
                suggestions: r.your_valuable_suggestions,
            });
        } catch (error) {
            console.error('Print error:', error);
            Swal.fire('Error!', 'Could not load data for printing.', 'error');
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (!selectedRow) return;

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!'
        });

        if (result.isConfirmed) {
            const formData = new FormData();
            const formattedRecord = { ...newRecord };

            // Format date
            if (formattedRecord.feedback_date) {
                formattedRecord.feedback_date = formatDate(formattedRecord.feedback_date);
            }

            // Append only non-empty fields
            for (const key in formattedRecord) {
                const value = formattedRecord[key];
                if (value !== null && value !== undefined && value !== 'null' && value !== '') {
                    formData.append(key, value);
                }
            }

            try {
                await axios.put(
                    `https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`,
                    formData
                );

                setData(data.map(item =>
                    item.mas_id === selectedRow.mas_id ? { ...item, ...newRecord } : item
                ));

                $('#editRowModal').modal('hide');

                // Optional: Cleanup after modal is hidden
                $('#editRowModal').on('hidden.bs.modal', function () {
                    $('body').removeAttr('style');
                    setTimeout(() => {
                        if ($('.content-wrapper').length) {
                            $('.content-wrapper').css('min-height', '100vh');
                        }
                        window.dispatchEvent(new Event('resize'));
                    }, 200);
                });

                Swal.fire('Saved!', 'The record has been updated.', 'success');
            } catch (error) {
                console.error('Error updating data:', error);
                Swal.fire('Error!', 'There was an issue updating the record.', 'error');
            }
        }
    };


    const handleInputChange = (e) => {
        const { id, value } = e.target;

        // Create a new object to update the state correctly
        const updatedRecord = { ...newRecord, [id]: value };

        // Update the state with the new record
        setNewRecord(updatedRecord);
    };

    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }

        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/?batch_no=${selectedBatchNo}`);
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        }
    };

    // Helper function to convert 'DD/MM/YYYY' to 'YYYY-MM-DD'
    function formatDateToInput(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const formatDate = (date) => {
        if (!date) return null;
        return new Date(date).toISOString().split('T')[0]; // "YYYY-MM-DD"
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo(''); // Clear dropdown selection
        setData([]); // Clear DataTable data
    };

    const filteredData = data.filter(item => {
        return (
            (item.batch_no && item.batch_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.sr_no && item.sr_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.training_title && item.training_title.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.designation && item.designation.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.contact_no && item.contact_no.toLowerCase().includes(searchText.toLowerCase()))
        );
    });


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '70px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no,
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.Name}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>training Title</span>,
            selector: row => row.training_title,
            width: '200px',
            sortable: true,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.training_title}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Designation</span>,
            selector: row => row.designation,
            width: '150px',
            sortable: true,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.designation}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Contact No</span>,
            selector: row => row.contact_no,
            width: '120px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Feedback Status</span>,
            selector: row => row.feedback_status,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Action</span>,
            cell: row => (
                <div className="gap-2">
                    <button className="btn btn-primary btn-sm me-2" onClick={() => handleEdit(row)}>
                        <i className="fa fa-edit"></i>
                    </button>
                    <button className="btn btn-primary btn-sm me-2" onClick={() => handlePrint(row)}>
                        <i className="fa fa-print"></i>
                    </button>
                </div>
            ),
            width: '120px',
            ignoreRowClick: true,
            allowoverflow: true,
        }
    ];

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Participant Feedback</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Participant Feedback</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filter Section */}
            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-filter mr-2"></i> Filter Records</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>

                                <div className="form-group col-md-3">
                                    <label>Select Batch Number</label>
                                    <select
                                        id="batchNumber"
                                        className="form-control select2"
                                        value={selectedBatchNo}
                                        onChange={(e) => setSelectedBatchNo(e.target.value)}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map(batchNo => (
                                            <option key={batchNo} value={batchNo}>{batchNo}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3 d-flex gap-2">
                                    <button
                                        className="btn btn-primary mr-2"
                                        onClick={handleViewButtonClick}
                                    >
                                        <i className="fas fa-eye mr-1"></i> View
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={handleResetButtonClick}
                                    >
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>

                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Results Section */}
            <div className="row">
                <div className="col-12">
                    <div className="card card-info card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-comments mr-2"></i> Feedback Results</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                            </div>

                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                    highlightOnHover
                                    striped
                                    className="table table-bordered table-hover"
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary">
                                                <h4 className="modal-title">Edit Participent Feedback</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Feedback Date</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.feedback_date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Batch No</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.batch_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Training Title</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.training_title}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Roll No</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.sr_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Organization</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.organization}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Working Location</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.work_location}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Name</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.Name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Designation</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.designation}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Contact No</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.contact_no}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Qualification</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.qualification}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Date Of Birth</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {formatToDDMMYYYY(newRecord.date_of_birth)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Languages Known</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <div style={{ padding: '0', fontSize: '1rem', textAlign: 'left' }}>
                                                                        {newRecord.languages_known}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-section">
                                                        <hr></hr>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Feedback Date</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        type="date"
                                                                        value={formatDateToInput(newRecord.feedback_date)}
                                                                        onChange={(e) => setNewRecord(prev => ({ ...prev, feedback_date: e.target.value }))}
                                                                        className="form-control"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Trainer Name</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="trainers_name"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.trainers_name}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Training Module</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="training_module"
                                                                        className="form-control select2"
                                                                        value={newRecord.training_module}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Average">Average</option>
                                                                        <option value="Good">Good</option>
                                                                        <option value="V.Good">V.Good</option>
                                                                        <option value="Excellent">Excellent</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Trainers</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="trainers"
                                                                        className="form-control select2"
                                                                        value={newRecord.trainers}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Average">Average</option>
                                                                        <option value="Good">Good</option>
                                                                        <option value="V.Good">V.Good</option>
                                                                        <option value="Excellent">Excellent</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>About EWE Training Facility </label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="training_facility"
                                                                        className="form-control select2"
                                                                        value={newRecord.training_facility}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Average">Average</option>
                                                                        <option value="Good">Good</option>
                                                                        <option value="V.Good">V.Good</option>
                                                                        <option value="Excellent">Excellent</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>I Learnt Something Useful</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="learn_something"
                                                                        className="form-control select2"
                                                                        value={newRecord.learn_something}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Remarks</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="learn_something_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.learn_something_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Food </label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="about_food"
                                                                        className="form-control select2"
                                                                        value={newRecord.about_food}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Average">Average</option>
                                                                        <option value="Good">Good</option>
                                                                        <option value="V.Good">V.Good</option>
                                                                        <option value="Excellent">Excellent</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Will You Recommend to Colleague?</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="recommend_colleague"
                                                                        className="form-control select2"
                                                                        value={newRecord.recommend_colleague}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Remarks</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="recommend_colleague_remark"
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={newRecord.recommend_colleague_remark}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3 align-items-center'>
                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Your valuable Suggestions</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <input
                                                                        id="your_valuable_suggestions"
                                                                        type="textarea"
                                                                        className="form-control"
                                                                        value={newRecord.your_valuable_suggestions}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="row align-items-center">
                                                                <div className="col-md-4">
                                                                    <label>Feedback Status</label>
                                                                </div>
                                                                <div className="col-md-8">
                                                                    <select
                                                                        id="feedback_status"
                                                                        className="form-control select2"
                                                                        value={newRecord.feedback_status}
                                                                        onChange={handleInputChange}
                                                                    >
                                                                        <option value=""></option>
                                                                        <option value="Updated">Updated</option>
                                                                        <option value="Not Updated">Not Updated</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer border-0">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success"
                                                        >
                                                            Save Changes
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            data-dismiss="modal"
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParticipentFeedback;
